import Axios from 'axios'
import { relevant } from '../common/util'



export default {
    brand: "CHUiSaver",
    project: "isaver-quote",
    projectTitle: "Flex Insurance",
    documentTitle: "Get a Quote | Residential Strata Insurance",
    paymentSuccessRedirect: "http://www.flexinsurance.com.au ",
    environment: process.env.REACT_APP_ENVIRONMENT,
    icon: require("./images/favicon.ico"),
    axios: Axios.create(),
    
  
    endpoints:{

        marketting:         `${process.env.REACT_APP_ENDPOINT_HOST}/webforms/common/marketting`,

        quoteSetup:         `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_ISAVERRESI_PATH}/quotesetup/v1`,
        quickQuote:         `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_ISAVERRESI_PATH}/quickquote/v1`,
        flatQuote:          `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_ISAVERRESI_PATH}/flatquote/v1`,
        finalise:           `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_ISAVERRESI_PATH}/finalise/v1`,
        
        email:              `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_ISAVERRESI_PATH}/documents/v1`,
        payOffline:         `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_ISAVERRESI_PATH}/documents/v1`,
        paymentAuthorise:   `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_ISAVERRESI_PATH}/authorise/v1`,
        paymentInitiate:    `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_ISAVERRESI_PATH}/initiate/v1`,
        payInstalments:     `${process.env.REACT_APP_INSTALMENTS_PATH}`,
        payInstalmentsMPF:  `${process.env.REACT_APP_INSTALMENTS_PATH_MPF}`,
        
        saveAndExit:        `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_ISAVERRESI_PATH}/quotesaveandexit/v1`,
        findToken:          `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_ISAVERRESI_PATH}/findtoken/v1`,
        restore:            `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_ISAVERRESI_PATH}/details/v1`,

        options:            `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_ISAVERRESI_PATH}/options/v2`,
        excesses:           `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_ISAVERRESI_PATH}/excesses/v2`,
        limits:             `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_ISAVERRESI_PATH}/limits/v2`,
        sumsinsured:        `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_ISAVERRESI_PATH}/sumsinsured/v2`,
        paymentOptions:     `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_ISAVERRESI_PATH}/paymentOptions/v1`,
        validateAddress:    `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_ISAVERRESI_PATH}/validateaddress/v2`,

        suburbAutoComplete: `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_POSTCODE_PATH}`
    },


    // RESTORE
    restore:{
        transformer: fields => fields,
        fieldNames:{ 
            quoteNumber: "quoteNumber",
            email: "requester.email"
        }
    },

    // PROGRESS
    progressGroups: [{
        "/step-1": "Step 1",
        "/step-2": "Step 2",
        "/step-3": "Step 3",
        "/step-4": "Quick Summary",
        "placeholderA": "..."
    },{
        "placeholderB": "...",
        "/step-5": "Optional Covers",
        "/step-6": "Building",
        "/step-7": "Premium Summary"
    }],

}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/isaver-quote/config.ts